export default __webpack_public_path__ + "static/media/screenShots_new-year-1.b6989e47.jpg";